import React, { useState } from "react";
import LoadContent from "components/LoadContent";
import HeaderSortBlock from "screens/SearchResult/components/ProductsList/components/HeaderSortBlock";
import Spinner from "components/Spinner";
import Pageination from "components/Pageination";
import ProductCard from "components/ProductCard";
import { useSelector } from "react-redux";
import { selectMain } from "store/selector";
import langData from "lang/data";

function normalizeProductForCard(item) {
  if (!item) return item;
  if (item.product && (item.skus?.length || item.skus)) return item;
  if (item.pricing || item.seller_id) {
    const prod = item.product ?? item;
    const pricing = item.pricing ?? {};
    return {
      id: item.seller_id ?? item.id,
      product: {
        ...prod,
        brand: item.brand ?? prod.brand,
        product_name: item.product_name ?? prod.product_name,
        sticker: item.sticker ?? prod.sticker,
        online_price: item.online_price ?? prod.online_price ?? (pricing.is_online ? 1 : 0),
        online_selling_price: item.online_selling_price ?? prod.online_selling_price ?? pricing.online_selling_price,
        categories: item.categories ?? prod.categories ?? (item.category ? [item.category] : []),
        gallary_images_api: item.gallary_images_api ?? prod.gallary_images_api ?? item.media,
        guaranty: item.guaranty ?? item.guaranty_name ?? prod.guaranty,
        gift_images: item.gift_images ?? prod.gift_images,
        cashback: pricing.cashback ?? prod.cashback,
        installing_price: pricing.installing_price ?? item.installing_price ?? prod.installing_price,
      },
      skus: item.skus?.length ? item.skus : [{
        selling_price: pricing.selling_price ?? item.selling_price,
        promo_price: pricing.promo_price ?? item.promo_price,
        id: item.seller_product_skus ?? item.product_sku_id ?? item.seller_id ?? item.id,
      }],
      promo_price: pricing.promo_price ?? item.promo_price,
      categories: item.categories ?? (item.category ? [item.category] : []),
    };
  }
  return item;
}

const NewProductList = ({
  handlePagination,
  currentPage,
  styles, 
  handleMoreProducts,
  category,
  loading, 
  handleMoreProduct,
  recordPage,
  setRecordPage,
  searchParams,
  setSearchParams
}) => {
  const { currentLanguage } = useSelector(selectMain);

  const [isToggle, setIsToggle] = useState(false); 

  const handleRecordNumber = (number) => {
    searchParams.delete("page");
    setRecordPage(number);
    handleMoreProducts(number);
    setIsToggle(false);
  };
  const handleSelectSorting = (sort) => {
    searchParams.delete("page");

    if (searchParams.get("s") === sort) {
      searchParams.delete("s");
    } else {
      searchParams.set("s", sort); 
    }
    setSearchParams(searchParams);
  };

    console.log(category)

  return (
    <>
      {loading ? (
        <LoadContent containerClassName={styles.categoryProductListLoad} />
      ) : (
        <>
          <HeaderSortBlock handleSelectSorting={handleSelectSorting}/>
          {category?.products?.length ? (
            <>
              <div className={styles.productList} >
                {category?.products?.map((item, index) => (
                  <ProductCard
                    key={item?.id ?? item?.seller_id ?? index}
                    product={normalizeProductForCard(item)}
                    containerStyle={styles.container}
                    flexContainer
                  />
                ))}
              </div>
           
              {((category?.productCount > 20 &&  category?.currentPage < category?.totalPages) ) && (
                <div className={styles.categoryMore}>
                  {loading ? (
                    <Spinner
                      width="30px"
                      height="30px"
                    />
                  ) : (
                    <span  onClick={() => handleMoreProduct()}>
                      {langData?.product?.show_more?.[currentLanguage]}
                    </span>
                  )}
                </div>
              )}

              {/*{ category?.lastPage > 1    && (*/}
                <div className={styles.productListPagination}>
                  <Pageination
                    nPages={category?.pagination?.lastPage }
                    currentPage = {currentPage} 
                    setCurrentPage = {handlePagination}
                  />
                  <div className={styles.categoryRecordPage}>
                    <span>{langData.product.record?.[currentLanguage]}:</span>
                    <div
                      onClick={() => setIsToggle(!isToggle)}
                      className={styles.categoryRecordSelect}>
                      <span>{recordPage}</span>
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M1.0293 5L4.99991 0.97083L9.02908 4.94145"
                          stroke="#282828"></path>
                      </svg>
                      {isToggle && (
                        <div className={styles.categorySelectList}>
                          {[20, 40, 60]?.map((item) => (
                            <span
                              onClick={() => handleRecordNumber(item)}
                              key={item}>
                              {item}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              {/*)}*/}
            </>
          ) : (
            <h3 className={styles.notFound}>
              {langData.titles.SearchNull?.[currentLanguage]}
            </h3>
          )}
        </>
      )}
    </>
  );
};

export default NewProductList;
